import React from 'react';
import PropTypes from 'prop-types';
import { FormGroup, ControlLabel, FormControl, HelpBlock } from 'react-bootstrap';

export default class BasicFormField extends React.Component {
  static propTypes = {
    error: PropTypes.string,
    label: PropTypes.string.isRequired,
    required: PropTypes.bool
  };

  static defaultProps = {
    error: undefined,
    required: false,
    Component: null,
    type: 'text'
  };

  render() {
    const { error, label, required } = this.props;
    let hint = null;
    let validationState = null;

    switch (error) {
      case 'invalid':
        hint = 'Neplatná hodnota';
        validationState = 'error';
        break;
      case 'required':
        hint = 'Povinný údaj';
        validationState = 'error';
        break;
    }

    return (
      <FormGroup validationState={validationState}>
        <ControlLabel>
          {required && <abbr title="vyžadováno">*&nbsp;</abbr>}
          {label}
        </ControlLabel>
        <FormControl {...this.props} />
        { hint && <HelpBlock>{hint}</HelpBlock> }
      </FormGroup>
    );
  }
}



// WEBPACK FOOTER //
// ./src/browser/Feature/components/basic_form_field.jsx